import styled from "styled-components";

export const NoticeList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
    max-width: 760px;
    margin: 0 auto;
`;

export const NoticeMediaWrap = styled.div`
    img, video { max-height: min(78dvh, 680px); }
`;

export const NoticeTextButton = styled.button`
    padding: 0;
    border: 0;
    background: none;
    color: inherit;
    text-align: left;
    font: inherit;
    font-weight: 600;
    cursor: pointer;
`;

export const NoticeReactionsBar = styled.div`
    display: flex;
    align-items: center;
    margin: 16px 20px 0;
    border: 1px solid #eee;
    border-radius: 999px;
    box-shadow: 0 2px 5px #0002;
    overflow: hidden;
    > button { min-height: 44px; border: 0; background: #fff; color: #000; padding: 8px 14px;
        font: inherit; font-size: 14px; text-align: left; cursor: pointer; }
    > button:first-child { font-size: 26px; border-right: 1px solid #eee; flex-shrink: 0; }
    > button:last-child { min-width: 0; flex: 1; overflow-wrap: anywhere; }
    > button:disabled { cursor: default; opacity: 0.6; }
`;

export const NoticeDiscussion = styled.section`
    border-top: 1px solid #eee;
    padding: 20px;
    h3 { margin: 0 0 16px; font-size: 20px; }
    textarea { font-size: 16px; }
    button[type="submit"] { background: #000; color: #fff; border-color: #000; }
    button:not([type="submit"]) { color: #000; }
`;

export const NoticeFooter = styled.div`
    border-top: 1px solid #eee;
    padding: 24px 20px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 16px;
`;
